import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Notice} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {NoticesService} from "../../../services/notices.service";

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'notice-info-modal',
    templateUrl: './notice-info-modal.component.html',
    styleUrls: ['./notice-info-modal.component.scss']
})
export class NoticeInfoModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    categories: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Notice = new Notice();
    disabledSubmit = false;

    constructor(
        public api: ApiClientService,
        public noticesService: NoticesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        // this.getNoticeCategories();
        if (this.noticesService.noticeInNoticeModal) {
            this.data = this.noticesService.noticeInNoticeModal;
            // this.noticeName = this.data.noticeName;
            // this.categoryId = this.data.categoryId;
        }
    }

    hideModal() {
        this.noticesService.isNoticeInfoShow = false;
        this.noticesService.noticeInNoticeModal = null;
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.noticeName) toastr.warning('Notice name should not be blank.');
            return;
        }

        let data: any = this.noticesService.noticeInNoticeModal;
        data.noticeName = form.value.noticeName;
        data.noticeCategory = form.value.noticeCategory;
        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainNotices', `/v1/incident_report/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Notice successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Notice failed');
                }
            );
        } else {
            this.api.post('domainNotices', '/v1/incident_report.json', data).subscribe(
                () => this.updateView('Notice successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Notice failed');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.noticesService.getData();
        this.form.reset();
        this.hideModal();
    }

    back(): void {
        this.noticesService.isNoticeInfoShow = false;
        this.noticesService.isNoticeScheduleShow = true;
        this.noticesService.step = 'schedule';
    }

    noticeCategorySelect(arr: Array<any>) {
        return arr.map(
            noticeCategory => (
                {value: noticeCategory.id, optionText: noticeCategory.name}
            )
        );
    }

    getNoticeCategories() {
        const url = `/v1/notice-types.json`;
        this.api.get('domainIncidentReports', url).subscribe(
            res => {
                this.categories = [];
                const types = JSON.parse(res._body).entities || [];
                types.forEach(
                    type => this.categories.push({id: type.id, name: type.name})
                );
            },
            error => this.api.errorHandler(error, 'Failed get categories')
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/notices/notice-info-modal/notice-info-modal.component.ts